import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'
import { createTheme } from '@mui/material/styles';
import { ThemeProvider } from '@mui/material/styles';

/**
 * The theme object that defines the color palette and typography for the application.
 *
 * @typedef {Object} Theme
 * @property {Object} palette - The color palette for the theme.
 * @property {Object} typography - The typography settings for the theme.
 */

/**
 * The theme object that defines the color palette and typography for the application.
 *
 * @type {Theme}
 */

const theme = createTheme({
  palette: {
    primary: {
      main: '#1A578E', // Your primary color
      light: '#888fd6', // Lighter variant
      dark: '#334cb2', // Darker variant
      contrastText: '#ffffff', // Text color that contrasts with the primary color
      hover: '#f5f5f5', // Custom primary hover color
    },
    secondary: {
      main: '#19857b', // Your secondary color
      light: '#4ba9a5', // Lighter variant
      dark: '#13605e', // Darker variant
      contrastText: '#ffffff', // Text color that contrasts with the secondary color
      hover: '#f5f5f5', // Custom secondary hover color
    },
    // Add other colors as needed
  },
  typography: {
    fontFamily: 'Roboto, Arial, Arial Black, Helvetica, sans-serif',
  },
});
const displayRoot = document.getElementById('displayRoot');
const premium = displayRoot.getAttribute('premium') === 'true';
const viewer = displayRoot.getAttribute('viewer') === 'true';
const isAnon = displayRoot.getAttribute('isAnon') === 'true';

ReactDOM.createRoot(displayRoot).render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <App premium={premium} viewer={viewer} isAnon={isAnon} />
    </ThemeProvider>
  </React.StrictMode>,
)
